module.exports = __webpack_public_path__ + "img/search_detail_info.61fd904c.png";